import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import { formatDuration } from "@signolteam/shared/units-of-measure";

let defaultMetadata = {
  thruster_event_used_signed_time_difference_minutes: 4,
  reference_time_used: "voyage_end_datetime",
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  metadata = defaultMetadata,
  missingDataMsg,
  bvrColour,
  isExample,
}) {
  const thrusterTimeDiffMinutes = Number(
    metadata["thruster_event_used_signed_time_difference_minutes"],
  );
  const refTimeUsed = metadata["reference_time_used"];
  const isArrival =
    refTimeUsed === "voyage_end_datetime" ||
    refTimeUsed === "all_fast_datetime";
  const thesholdMinutes = isArrival ? 5 : -10;

  if (isNaN(thrusterTimeDiffMinutes) || isNaN(thesholdMinutes)) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  const referenceTimeName = isArrival
    ? refTimeUsed === "voyage_end_datetime"
      ? "arrival"
      : "all fast"
    : refTimeUsed === "voyage_start_datetime"
      ? "departure"
      : "single up";

  const thresholdLabel = isArrival
    ? `Signol threshold (${thesholdMinutes} min after ${referenceTimeName})`
    : `Signol threshold (${Math.abs(thesholdMinutes)} min before ${referenceTimeName})`;
  const data = [
    {
      beforeThreshold: isArrival
        ? thrusterTimeDiffMinutes > thesholdMinutes
          ? thesholdMinutes
          : thrusterTimeDiffMinutes
        : thrusterTimeDiffMinutes > thesholdMinutes
          ? thrusterTimeDiffMinutes
          : thesholdMinutes,
      afterThreshold: isArrival
        ? thrusterTimeDiffMinutes > thesholdMinutes
          ? thrusterTimeDiffMinutes - thesholdMinutes
          : 0
        : thrusterTimeDiffMinutes > thesholdMinutes
          ? 0
          : thrusterTimeDiffMinutes - thesholdMinutes,
      underThresholdColour: isArrival
        ? thrusterTimeDiffMinutes <= thesholdMinutes
          ? bvrColour.codes["500"]
          : bvrColour.codes["200"]
        : thrusterTimeDiffMinutes <= thesholdMinutes
          ? bvrColour.codes["200"]
          : bvrColour.codes["500"],
      overThresholdColour: bvrColour.codes["900"],
    },
  ];

  const domainMin =
    Math.min(thesholdMinutes, thrusterTimeDiffMinutes, 0) +
    Math.min(
      (Math.min(thesholdMinutes, thrusterTimeDiffMinutes, 0) / 100) * 35,
      -10,
    ); // add 35% or 10 which ever is more for label space
  const domainMax =
    Math.max(thesholdMinutes, thrusterTimeDiffMinutes, 0) +
    Math.max(
      (Math.max(thesholdMinutes, thrusterTimeDiffMinutes, 0) / 100) * 35,
      10,
    ); // add 35% or 10 which ever is more for label space
  const domain = [domainMin, domainMax];

  const thresholdLineColour = bvrColour.codes["900"];

  const ticks = [];
  for (let i = domainMin + 1; i < domainMax; i++) {
    ticks.push(i);
  }

  const labelFormatter = (value) =>
    `${formatDuration(Math.abs(value) * 60, { boundaryValues: [0, thesholdMinutes * 60] }).formattedValue} ${
      thrusterTimeDiffMinutes < 0 ? "before" : "after"
    } ${referenceTimeName}`;

  return (
    <BehaviourBarGraph
      invertBarLabels={thrusterTimeDiffMinutes < 0 ? true : false}
      data={data}
      moveOrigin={true}
      hideYAxisOnDesktop={true}
      hideXLineOnMobile={true}
      threshold={thesholdMinutes}
      thresholdLabel={thresholdLabel}
      originLabel={
        String(referenceTimeName).charAt(0).toUpperCase() +
        String(referenceTimeName).slice(1)
      }
      mobileDomain={domain}
      domain={domain}
      refLineColour={thresholdLineColour}
      success={!(Math.abs(thesholdMinutes) < Math.abs(thrusterTimeDiffMinutes))}
      axisLabel={`Thruster ${isArrival ? "off" : "on"} time relative to ${referenceTimeName}`}
      hideYLine={true}
      hideNum={true}
      showTicks={true}
      hideTopLabel={true}
      barLabelFormatter={labelFormatter}
      barLabelFormatterMobile={labelFormatter}
      ticks={ticks}
      isExample={isExample}
    />
  );
}
